module.exports = __webpack_public_path__ + "img/undraw_my_current_location.c21ecc2d.svg";